import React from 'react';
import SectionPliable from '../../../composants/SectionPliable/SectionPliable';
import { CommandeMS } from '../types';
import { PositionCandidat } from '../domain/commandeMsMarche';

interface CommandeMsMarcheCandidatProps {
  commande: CommandeMS;
  position: PositionCandidat;
  // Date deja formatee ("02/07/2026 à 14:51"), calculee par le parent (partagee avec l'apercu du mail).
  dateNotification: string | null;
  // Ouvre l'apercu du mail de notification recu (retenu) ou du message de rejet (non-retenu).
  onSeeMessage: () => void;
}

const PLACEHOLDER = '—';

// Section « Information aux candidats » de la vue PRESTATAIRE : STRICTEMENT sa propre ligne. Cote
// acheteur (OperationMarcheCandidats) la section liste le retenu ET les non-retenus, avec le bouton
// « Informer le candidat ». Ici aucun autre candidat n'est expose et aucune action d'envoi n'existe :
// le prestataire ne fait que constater sa position et la date a laquelle il a ete informe.
const CommandeMsMarcheCandidat: React.FC<CommandeMsMarcheCandidatProps> = ({
  commande,
  position,
  dateNotification,
  onSeeMessage,
}) => {
  const entite = commande.contrat?.entite as
    | { nom?: string; interlocuteur?: { email_contact?: string } }
    | undefined;
  const nom = entite?.nom || 'Nom inconnu';
  const mail = entite?.interlocuteur?.email_contact || PLACEHOLDER;

  const estRetenu = position === 'retenu';

  return (
    <SectionPliable title="Information aux candidats" defaultOpen>
      <div className="opms__marche-body">
        <div className="opms__candidats">
          <div className="opms__candidats-row opms__candidats-head">
            <span>{estRetenu ? 'Retenu' : 'Non retenu'}</span>
            <span>Mail</span>
            <span>{estRetenu ? 'Contenu de la notification' : 'Contenu du message de rejet'}</span>
            <span>{estRetenu ? 'Notification' : 'Information de rejet'}</span>
          </div>
          <div className="opms__candidats-row">
            <span className="opms__candidats-nom">{nom}</span>
            <span className="opms__candidats-mail">{mail}</span>
            <span>
              <button type="button" className="opms__candidats-link" onClick={onSeeMessage}>
                Voir le message
              </button>
            </span>
            <span>
              {dateNotification
                ? `${estRetenu ? 'Notifié' : 'Diffusé'} le ${dateNotification}`
                : PLACEHOLDER}
            </span>
          </div>
        </div>
      </div>
    </SectionPliable>
  );
};

export default CommandeMsMarcheCandidat;
